export default __webpack_public_path__ + "static/media/default_intra.1ca2a224.png";